import { makeStyles } from '@mui/styles';
import {  colors } from '@mui/material';

export const useStyles = makeStyles((theme) => ({
  root: {},
  title: {
    color: theme.palette.gray[5],
  },
  titleIcon: {
    fontSize: 18,
    marginInlineStart: theme.spacing(2),
  },
  titleText: {
    fontSize: 14,
    marginInlineStart: theme.spacing(1),
    paddingTop: theme.spacing(0.5),
    fontWeight: 'bold',
  },
  docItemsContainer: {
    marginTop: theme.spacing(1),
  },
  detail: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(1),
  },
  detailTitle: {
    fontSize: 12,
    color: '#546e7a',
    marginBottom: theme.spacing(1),
  },
  detailValue: {
    fontSize: 14,
    marginBottom: theme.spacing(0.5),
  },
  error: {
    color: colors.red.A700,
  },
  cancelReqButton: {
    marginInlineEnd: theme.spacing(1),
    border: '1px solid rgba(0,0,0,.3) !important',
  },
  notAvailabelBranch: {
    textAlign: 'center',
    padding: theme.spacing(3),
    fontWeight: 'bold',
    fontSize: 15,
  },
}));